import { render } from "./fund.vue?vue&type=template&id=707106c8&scoped=true"
import script from "./fund.vue?vue&type=script&lang=js"
export * from "./fund.vue?vue&type=script&lang=js"

import "./fund.vue?vue&type=style&index=0&id=707106c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707106c8"]])

export default __exports__